module.exports = new __parcel__URL__("../assets/pc-white-nobg.493ceed4.png").toString();